<div (click)="click()" class="mb14 flex task pointer">
  <div *ngIf="task.seen == 0" class="badge hide-on-phone">
    nieuw
  </div>

  <div [ngClass]="task.seen == 0 ? 'new': ''" class="task-client-name hide-on-phone">
    {{task.clientFullName}}
  </div>

  <div>
      <strong>
        {{ reportService.getReportName(task.reportType) }} {{ task.year }}
      </strong>
      <small class="subtitle">
        <span *ngIf="task.reportType === 'BB'">
          een boedelbeschrijving dient uiterlijk 4 maanden na de aanvang van het bewind ingeleverd te worden ({{task.deadline}})
        </span>

        <span *ngIf="task.reportType === 'VJE'">
          een vijfjaarlijkse evaluatie dient iedere 5 jaar, rekenend vanaf de ingangsdatum van het bewind, ingediend te
          worden ter controle bij de rechtbank.
        </span>

        <span *ngIf="task.reportType === 'ERV' || task.reportType === 'ERVO'">
          Bij het einde van het bewind of de curatele, of bij het einde van uw werkzaamheden als bewindvoerder of
          curator, maakt u over de laatste periode een overzicht van de inkomsten en uitgaven, het vermogen en de
          eventuele schulden van de betrokkene.
        </span>

        <span *ngIf="task.reportType === 'RV'">
          een rekening en verantwoording dient ingeleverd te worden in het jaar volgend op het rapportage jaar
          afhankelijk van de rechtbank op de aanvangsdag/maand van het bewind of op 31 december van dat jaar
          raadpleeg de documentatie van uw bewind of informeer bij de rechtbank voor de juiste uiterste inleverdatum
        </span>

        <span *ngIf=" inThePast(task.deadline)" [ngClass]="'task-'+task.level">
          (achterstallig)
        </span>
      </small>
  </div>
</div>
